import React from 'react';

interface Props {
	size: number;
}

export const ExcitedIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		className='margin--8'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>excited</title>
		<path d='M7.27 12.41a1.63 1.63 0 111.63-1.63 1.63 1.63 0 01-1.63 1.63zm0-2.43a.81.81 0 10.81.8.81.81 0 00-.81-.78zM17 12.41a1.63 1.63 0 111.63-1.63A1.63 1.63 0 0117 12.41zM17 10a.81.81 0 10.81.8.81.81 0 00-.81-.8z' />
		<path d='M12 23.36A11.36 11.36 0 1123.36 12 11.38 11.38 0 0112 23.36zm0-21.9A10.54 10.54 0 1022.54 12 10.55 10.55 0 0012 1.46z' />
		<path d='M12 17.81a3.25 3.25 0 01-3.38-3.11v-.41h6.76v.41A3.25 3.25 0 0112 17.81zm-2.52-2.7A2.5 2.5 0 0012 17a2.5 2.5 0 002.52-1.89z' />
	</svg>
);
